<template>
  <div class="anchor-id">
    <div class="text-right mb-20">
      <el-button size="mini" type="primary" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="tableData"
    />
  </div>
</template>

<script>
import { getNativeAnchorApi, pullNativeAnchorApi } from '@/api/tool/native-anchor';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
    // 当前广告主ID
    advertiserId: {
      type: String,
      required: true,
    },
    // 渠道号
    channelAlias: {
      type: Array,
      required: true,
    },
    // 表格数据
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
    };
  },
  computed: {
    channel_interface() {
      const { channel_interface } = this.initOps;
      return channel_interface;
    },
  },
  created() {
    if (this.formItem.value.result_value.length) {
      this.edit();
    } else {
      this.generateTableData();
    }
  },
  methods: {
    /**
     * 生成表格数据
     */
    async generateTableData() {
      const result = await this.getNativeAnchorList({ advertiser_id: this.advertiserId, channel_interface: this.channel_interface });
      const data = this.channelAlias.map(({ alias }) => {
        return {
          advertiser_id: this.advertiserId,
          channel_alias: alias,
          type: { options: this.formItem.value.type_selection, value: 'APP_GAME' },
          target: { ...this.initTarget(result) },
        };
      });
      this.tableData.push(...data);
    },
    /**
     * 编辑
     */
    edit() {
      const data = this.formItem.value.result_value.filter(({ advertiser_id }) => advertiser_id === this.advertiserId)
        .map(({ advertiser_id, channel_alias, type, options, value }) => {
          return {
            advertiser_id,
            channel_alias,
            type: { options: this.formItem.value.type_selection, value: type },
            target: { ...this.initTarget(options, value) },
          };
        });
      this.tableData.push(...data);
    },
    /**
     * 初始化目标
     * @returns {Object}
     */
    initTarget(init_options = [], init_value = '') {
      const target = {};
      this.formItem.value.type_selection.forEach(({ value }) => {
        Object.assign(target, {
          [value]: {
            options: init_options,
            value: init_value,
          },
        });
      });
      return target;
    },
    /**
     * 获取原生锚点列表
     * @param {Object} params 请求参数
     * @returns {Promise<Object[]>}
     */
    getNativeAnchorList(params) {
      return new Promise((resolve, reject) => {
        getNativeAnchorApi(params).then(({ list = [] }) => {
          const result = list.map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 同步
     */
    async onPull() {
      const { message } = await pullNativeAnchorApi({ advertiser_id: this.advertiserId, channel_interface: this.channel_interface });
      const result = await this.getNativeAnchorList({ advertiser_id: this.advertiserId, channel_interface: this.channel_interface });
      this.tableData.forEach(({ type, target }) => {
        target[type.value].options = result;
      });
      this.$message.success(message || '同步成功');
    },
  },
};
</script>

<style lang="scss" scoped>
.anchor-id {
  padding: 20px;
}
</style>
